import { PlusOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import "./section-four-add-record-button.scss";

type SectionFourAddRecordButtonProps = {
  disabled: boolean;
  tooltip?: string;
  onClick: () => void;
};

export const SectionFourAddRecordButton = ({
  disabled,
  tooltip,
  onClick,
}: SectionFourAddRecordButtonProps) => {
  const button = (
    <Button
      type="primary"
      icon={<PlusOutlined />}
      onClick={onClick}
      disabled={disabled}
      style={{
        backgroundColor: disabled ? "rgba(119, 119, 119, 1)" : undefined,
        borderColor: disabled ? "rgba(119, 119, 119, 1)" : undefined,
      }}
    >
      Добавить запись
    </Button>
  );

  if (!disabled || !tooltip) {
    return button;
  }

  return (
    <Tooltip title={tooltip}>
      <span className="section-four-add-record-button__tooltip-target">
        {button}
      </span>
    </Tooltip>
  );
};
